import { render, staticRenderFns } from "./ReportMaterialsDebits.vue?vue&type=template&id=241f0e24&"
import script from "./ReportMaterialsDebits.vue?vue&type=script&lang=js&"
export * from "./ReportMaterialsDebits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QInput,QCheckbox,QBanner,QIcon,QDialog,QCard,QCardSection,QScrollArea,QItem,QSeparator,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QBtn,QInput,QCheckbox,QBanner,QIcon,QDialog,QCard,QCardSection,QScrollArea,QItem,QSeparator,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
